/* eslint-disable @typescript-eslint/ban-ts-comment */

const getRedirectData = () => {
  // @ts-ignore
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  const params = new URLSearchParams(window.location.search);

  if (params.get("redirectToNativeStore") !== "true") {
    return { willRedirectToStore: false, url: null };
  }

  // @ts-ignore
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
    return {
      willRedirectToStore: true,
      url: "https://apps.apple.com/pl/app/mybenefit/id1601176160?l=pl",
    };
  }

  if (/Android/i.test(ua)) {
    return {
      willRedirectToStore: true,
      url: "https://play.google.com/store/apps/details?id=com.mybenefit",
    };
  }

  if (/Huawei|Honor/i.test(ua)) {
    return {
      willRedirectToStore: true,
      url: "https://appgallery.huawei.com/app/C105648247",
    };
  }

  const url = new URL(window.location.href);
  url.searchParams.delete("redirectToNativeStore");

  return {
    willRedirectToStore: false,
    url: url.toString(),
  };
};

export default getRedirectData;
